import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators as actionCreatorsEvents } from '../actions/events';
import { actionCreators } from '../actions/instances';
import RegisterTableItem from './RegisterTableItem';
import '../styles/EventsTable.css';
import searching from '../images/searching.gif';
import Typography from '@material-ui/core/Typography';

import TablePaginationActionsWrapped from './TablePaginationActionsWrapped'

import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination
} from "@material-ui/core";

class RegisterHistoryTable extends Component {

  constructor(props){
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
    }
  } 

  handleChangePage = (event, page) => {
    this.setState({page});
  };

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value});
  };

  renderRegisterTable = (props) => {
    const {rowsPerPage, page} = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.props.registers.length - page * rowsPerPage)
    if(props.registers === undefined || props.registers.length === 0){
      return(
   <div class="eventsNotFoundChart">
    
      <Typography variant="h4" color="textSecondary">
            No registers found.
          </Typography>
          
        <br/>
        <img src={searching} alt="searching"/></div>);}
  else{
    return(
      <div className="EventsTable-Wrapper">
        <Table className="mb-0">
          <TableHead>
            <tr
              style= {
                {
                  fontSize: '1.3rem'
                }}
            >
              <th>Tag</th>
              <th>Value</th>
              <th>Created</th>
            </tr>
          </TableHead>
          <TableBody>
            {props.registers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(i =>
              <RegisterTableItem key={i.id} register={i} instance={this.props.instance} />
            )}
          </TableBody>
          <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={3}
                  count={this.props.registers.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
        </Table>
      </div>
  );}
  };

  render() {
    return (
      <div>
        {this.renderRegisterTable(this.props)}
      </div>
    );
  };
}

export default RegisterHistoryTable;


// WEBPACK FOOTER //
// ./src/components/RegisterHistoryTable.js